import React, { useRef, useEffect } from "react";
import dynamic from 'next/dynamic';
import Head from 'next/head'
import Image from 'next/image'
import { Inter } from 'next/font/google'

import Navbar from '../../../components/navbar';
import Footer from '../../../components/footer';
import Layout from '../../../components/layout';

const FaceMeshComponent = dynamic(() => import('../../../components/facemesh'), {
    ssr: false
  });
  

const HomePage = () => {
return (
  <>
    <Head>
      <title>AI Eye Shape Analyzer | StyleSense.io</title>
      <meta
        name="description"
        content="Simply take or upload a selfie to identify your eye shape, and prominent eye features. Then, use our eyeliner guides tailored to your eye features to learn how to best accentuate your beauty."
        key="desc"
      />
    </Head>    
    <Layout page={"face_analyzer/facial_feature"} selectedOption={"face_analyzer/facial_feature"}/>    
    {/* <main className="min-h-screen max-w-full overflow-x-hidden box-border flex flex-col justify-between items-center">
      <Navbar page={"face_analyzer/facial_feature"}/>
      <FaceMeshComponent page={"face_analyzer/facial_feature"}/>     
      <Footer />
    </main> */}
  </>
  )
}

export default HomePage;